export const TEST_ID = 'legalNavigationLink';
